export const TEST_ACTION = "TEST_ACTION";
export const CONVERSATION = "CONVERSATION";
export const GET_USER = "GET_USER";
